module.exports = __webpack_public_path__ + "static/media/icon-modal-download.760d86a6.svg";